package net.bothosting.docs.pages.hosting_in_bot_hosting_net

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initManage_server_subusersPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("hosting_in_bot_hosting_net/manage_server_subusers.md", FrontMatterElement.Builder { addScalar("description", "This guide explains how you can grant or revoke access to other users on your server."); addScalar("icon", "user-group"); }))
}

@Page("/hosting_in_bot_hosting_net/manage-server-subusers")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Manage_server_subusersPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("manage-server-subusers") }) {
        org.jetbrains.compose.web.dom.Text("Manage Server Subusers")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.TIP, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Please keep in mind that only users you grant access to can access your server.")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("how-to-give-access-to-other-users") }) {
        org.jetbrains.compose.web.dom.Text("How to give access to other users? ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#grant-access");attr("id", "grant-access")}) {
        }
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Open the server in the Control Panel.")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
            }
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (27).png");attr("alt", "")})
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
            }

        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Navigate to the Users tab.")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
            }
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (28).png");attr("alt", "")})
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
            }

        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Click the “New User” button.")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
            }
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (29).png");attr("alt", "")})
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
            }

        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Type in the email address of the user you want to give access to.")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
            }
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (30).png");attr("alt", "")})
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
            }

        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Select the permissions you want to give that user.")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
            }
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (31).png");attr("alt", "")})
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
            }

        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Click the “Invite User” button to confirm.")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
            }
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (33).png");attr("alt", "")})
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
            }

        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" The user will not receive an email. They can access the server only if a Discord account linked to that email address is registered on bot-hosting.net, and only through that account.")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("how-to-remove-access-for-a-user") }) {
        org.jetbrains.compose.web.dom.Text("How to remove access for a user? ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#remove-access");attr("id", "remove-access")}) {
        }
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Access the control panel and navigate to the Users tab, as explained in the “How to give access to other users?” section.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Click the trash bin (delete) button for the account you want to remove access from.")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
            }
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (34).png");attr("alt", "")})
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
            }

        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("how-to-edit-permissions-for-a-user") }) {
        org.jetbrains.compose.web.dom.Text("How to edit permissions for a user? ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#edit-access");attr("id", "edit-access")}) {
        }
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Access the control panel and navigate to the Users tab, as explained in the “How to give access to other users?” section.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Click the pencil (edit) button for the account you want to edit permissions for.")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
            }
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (35).png");attr("alt", "")})
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
            }

        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Make changes to the assigned permissions by clearing the checkboxes for permissions you want to revoke and selecting the checkboxes for permissions you want to grant.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("Save your changes with the “SAVE” button.")
            }
        }
    }
}
